import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';

export default function MobileStageDate({ date }: { date: string }) {
  const formattedDate = date ? moment(date).format('MMM DD') : 'Date';

  return <Typography>{formattedDate}</Typography>;
}
